import { createContext } from 'react';

var defaultValue = {
  inputRef: null,
  collectionRef: null
};
var SelectAutocompleteContext = /*#__PURE__*/createContext(defaultValue);

export { SelectAutocompleteContext };
//# sourceMappingURL=SelectAutocompleteContext.js.map
